import { z } from 'zod';
export const EVENT_CODES = [
    'order.received',
    // `01` §1.1 (traitement asynchrone du webhook), absent du tableau §9.1.
    'order.duplicate_webhook',
    'order.recovered_by_polling',
    'order.carrier_unmapped',
    'order.relay_missing',
    'order.field_truncated',
    'order.encoding_repaired',
    'order.tags_failed',
    'order.blocked',
    'order.no_lines',
    'order.fetch_failed',
    'file.sent',
    'file.upload_failed',
    'fulfillment.run_failed',
    'fulfillment.line_failed',
    'fulfillment.order_not_found',
    'fulfillment.file_changed',
    'fulfillment.no_files',
    'pennylane.run_failed',
    'pennylane.invoice_failed',
    'pennylane.pagination_cap',
    'shopify.uninstalled',
    'shopify.throttled',
    'webhook.invalid_hmac',
    // `01` §1.1 (identification de la boutique), absent du tableau §9.1.
    'webhook.unknown_shop',
    // `06` §9 — abonnements Recharge.
    'recharge.webhook.invalid_signature',
    'recharge.api.error',
    'recharge.handler.failed',
    'recharge.slack.failed',
    'recharge.export.failed',
    'recharge.canton_scan.failed',
    'recharge.klaviyo_sync.failed',
    'recharge.klaviyo_sync.profile_errors',
    // `07` §8 — remise sur le prochain renouvellement.
    'recharge.discount.run_failed',
    'recharge.discount.error_rate',
    'recharge.discount.code_public',
    'system.job_stuck',
    'maintenance.on',
    'maintenance.off',
    'user.action',
];
export const eventCodeSchema = z.enum(EVENT_CODES);
export const EVENT_CATALOGUE = {
    'order.received': {
        code: 'order.received',
        severity: 'info',
        email: false,
        slack: false,
        titleFr: 'Commande reçue',
        triggerFr: 'Commande reçue (webhook ou polling)',
    },
    'order.duplicate_webhook': {
        code: 'order.duplicate_webhook',
        severity: 'info',
        email: false,
        slack: false,
        titleFr: 'Webhook de commande en doublon',
        triggerFr: 'Commande déjà connue en base (même boutique et même identifiant)',
    },
    'order.recovered_by_polling': {
        code: 'order.recovered_by_polling',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Commande rattrapée par le polling',
        triggerFr: 'Commande manquée par les webhooks',
    },
    'order.carrier_unmapped': {
        code: 'order.carrier_unmapped',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Transporteur par défaut appliqué',
        triggerFr: 'Aucune règle transporteur ne correspond',
    },
    'order.relay_missing': {
        code: 'order.relay_missing',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Point relais sans identifiant',
        triggerFr: 'Livraison en point relais sans code relais dans les note_attributes',
    },
    'order.field_truncated': {
        code: 'order.field_truncated',
        severity: 'warning',
        email: false,
        slack: false,
        titleFr: 'Champ obligatoire tronqué',
        triggerFr: 'Un champ obligatoire dépasse la taille maximale Martelet',
    },
    'order.encoding_repaired': {
        code: 'order.encoding_repaired',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Encodage réparé',
        triggerFr: 'Champ au mojibake réparé automatiquement (fiche client à corriger dans Shopify)',
    },
    'order.tags_failed': {
        code: 'order.tags_failed',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Tag d’opération non posé',
        triggerFr: 'Échec de la mutation tagsAdd',
    },
    'order.blocked': {
        code: 'order.blocked',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Commande bloquée',
        triggerFr: 'Abonnement à composer ou encodage invalide (mojibake)',
    },
    'order.no_lines': {
        code: 'order.no_lines',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'CSV sans ligne article',
        triggerFr: 'Toutes les lignes de la commande ont été filtrées',
    },
    'order.fetch_failed': {
        code: 'order.fetch_failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Commande irrécupérable via l’API',
        triggerFr: 'Échec du rechargement de la commande après retries',
    },
    'file.sent': {
        code: 'file.sent',
        severity: 'info',
        email: false,
        slack: false,
        titleFr: 'Fichier envoyé',
        triggerFr: 'Upload FTP réussi',
    },
    'file.upload_failed': {
        code: 'file.upload_failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Envoi du fichier en échec',
        triggerFr: 'Upload en échec après épuisement des tentatives',
    },
    'fulfillment.run_failed': {
        code: 'fulfillment.run_failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Run Suivi Martelet en échec',
        triggerFr: 'FTP Martelet injoignable',
    },
    'fulfillment.line_failed': {
        code: 'fulfillment.line_failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Mise à jour Martelet non appliquée',
        triggerFr: 'Erreur de l’API Shopify sur une ligne de retour',
    },
    'fulfillment.order_not_found': {
        code: 'fulfillment.order_not_found',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Mise à jour Martelet : commande introuvable',
        triggerFr: 'La ligne OC1 ne se résout vers aucune commande',
    },
    'fulfillment.file_changed': {
        code: 'fulfillment.file_changed',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Fichier de suivi modifié',
        triggerFr: 'Fichier déjà traité dont le contenu a changé',
    },
    'fulfillment.no_files': {
        code: 'fulfillment.no_files',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Aucun retour Martelet',
        triggerFr: 'Aucun fichier O_COMMANDES depuis N jours ouvrés',
    },
    'pennylane.run_failed': {
        code: 'pennylane.run_failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Run Pennylane en échec',
        triggerFr: 'Listage des factures impossible',
    },
    'pennylane.invoice_failed': {
        code: 'pennylane.invoice_failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Facture Pennylane non envoyée',
        triggerFr: 'Facture incomplète ou en erreur',
    },
    'pennylane.pagination_cap': {
        code: 'pennylane.pagination_cap',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Plafond de pagination Pennylane atteint',
        triggerFr: 'Plafond de 200 pages atteint lors d’un listage',
    },
    'shopify.uninstalled': {
        code: 'shopify.uninstalled',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Application désinstallée',
        triggerFr: 'Webhook app/uninstalled reçu pour une boutique',
    },
    'shopify.throttled': {
        code: 'shopify.throttled',
        severity: 'warning',
        email: false,
        slack: false,
        titleFr: 'Limite de débit Shopify',
        triggerFr: 'Réponse THROTTLED de l’API Admin GraphQL',
    },
    'webhook.invalid_hmac': {
        code: 'webhook.invalid_hmac',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Signature de webhook invalide',
        triggerFr: 'HMAC-SHA256 du corps brut non vérifiée',
    },
    'webhook.unknown_shop': {
        code: 'webhook.unknown_shop',
        severity: 'warning',
        email: false,
        slack: false,
        titleFr: 'Webhook d’une boutique inconnue',
        triggerFr: 'En-tête X-Shopify-Shop-Domain inconnu, ou boutique déconnectée',
    },
    'recharge.webhook.invalid_signature': {
        code: 'recharge.webhook.invalid_signature',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Webhook Recharge refusé',
        triggerFr: 'Signature X-Recharge-Hmac-Sha256 invalide, absente, ou client secret non configuré',
    },
    'recharge.api.error': {
        code: 'recharge.api.error',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Erreur de l’API Recharge',
        triggerFr: 'Appel à l’API Recharge en échec après les relances',
    },
    'recharge.handler.failed': {
        code: 'recharge.handler.failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Webhook Recharge non traité',
        triggerFr: 'Traitement d’un webhook Recharge en échec définitif',
    },
    'recharge.slack.failed': {
        code: 'recharge.slack.failed',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Message Slack abonnements non délivré',
        triggerFr: 'Échec de l’envoi vers le webhook Slack du canal abonnements',
    },
    'recharge.export.failed': {
        code: 'recharge.export.failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Export des abonnements en échec',
        triggerFr: 'Génération de l’export des abonnements actifs interrompue',
    },
    'recharge.canton_scan.failed': {
        code: 'recharge.canton_scan.failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Vérification des cantons en échec',
        triggerFr: 'Vérification des adresses suisses Recharge interrompue',
    },
    'recharge.klaviyo_sync.failed': {
        code: 'recharge.klaviyo_sync.failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Synchronisation Klaviyo en échec',
        triggerFr: 'Synchronisation de la catégorie d’abonné vers Klaviyo interrompue, ou arrêtée par le garde-fou',
    },
    'recharge.klaviyo_sync.profile_errors': {
        code: 'recharge.klaviyo_sync.profile_errors',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Profils Klaviyo non mis à jour',
        triggerFr: 'Synchronisation Klaviyo terminée, mais Klaviyo a refusé la mise à jour de certains profils',
    },
    'recharge.discount.run_failed': {
        code: 'recharge.discount.run_failed',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Remise renouvellement : passe en échec',
        triggerFr: 'Passe initiale, réconciliation ou retrait des remises interrompu',
    },
    'recharge.discount.error_rate': {
        code: 'recharge.discount.error_rate',
        severity: 'warning',
        email: false,
        slack: true,
        titleFr: 'Remise renouvellement : remises perdues ou en erreur',
        triggerFr: 'Le nombre de remises perdues ou en erreur d’une passe dépasse le seuil réglé',
    },
    'recharge.discount.code_public': {
        code: 'recharge.discount.code_public',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Code de remise ouvert au public',
        triggerFr: 'Un code créé par Flux est utilisable au checkout ou dans le portail client',
    },
    'system.job_stuck': {
        code: 'system.job_stuck',
        severity: 'critical',
        email: true,
        slack: true,
        titleFr: 'Job bloqué',
        triggerFr: 'Job verrouillé depuis plus de 10 minutes',
    },
    'maintenance.on': {
        code: 'maintenance.on',
        severity: 'info',
        email: false,
        slack: false,
        titleFr: 'Envois vers Martelet suspendus',
        triggerFr: 'Suspension des envois vers Martelet',
    },
    'maintenance.off': {
        code: 'maintenance.off',
        severity: 'info',
        email: false,
        slack: false,
        titleFr: 'Envois vers Martelet repris',
        triggerFr: 'Reprise des envois vers Martelet',
    },
    'user.action': {
        code: 'user.action',
        severity: 'info',
        email: false,
        slack: false,
        titleFr: 'Action utilisateur',
        triggerFr: 'Action manuelle (utilisateur, cible, action)',
    },
};
/** Définition d'un code d'événement. */
export function eventDefinition(code) {
    return EVENT_CATALOGUE[code];
}
/** Tous les codes dont la sévérité est celle demandée. */
export function eventCodesBySeverity(severity) {
    return EVENT_CODES.filter((code) => EVENT_CATALOGUE[code].severity === severity);
}
/**
 * Événements de mécanique interne : vrais dans le journal, mais sans intérêt
 * au quotidien. L'onglet Journal les masque par défaut (`02` §11) ; la case
 * « Afficher les événements techniques » les rend visibles.
 */
export const TECHNICAL_EVENT_CODES = [
    'order.duplicate_webhook',
    'order.field_truncated',
    'shopify.throttled',
    'webhook.unknown_shop',
];
export function isTechnicalEventCode(code) {
    return TECHNICAL_EVENT_CODES.includes(code);
}
/** Codes qui déclenchent au moins un canal d'alerte (email ou Slack). */
export function alertingEventCodes() {
    return EVENT_CODES.filter((code) => EVENT_CATALOGUE[code].email || EVENT_CATALOGUE[code].slack);
}
/**
 * Objet d'un email d'alerte — `01` §9.2 :
 * `[Flux] <Critique|Avertissement> — <titre court>`.
 */
export function alertSubject(code, detail) {
    const definition = EVENT_CATALOGUE[code];
    const severityLabel = definition.severity === 'critical'
        ? 'Critique'
        : definition.severity === 'warning'
            ? 'Avertissement'
            : 'Info';
    const title = detail ? `${definition.titleFr} — ${detail}` : definition.titleFr;
    return `[Flux] ${severityLabel} — ${title}`;
}
//# sourceMappingURL=catalogue.js.map